
import {Vue, Component, Prop, Emit} from 'vue-property-decorator';
import {classesApi} from '@/api';

@Component
export default class Student_Course_Class extends Vue {
    @Prop({default: {}}) studentInfo?: any;
    @Emit('closeStudentModal') private closeStudentModal() {}
    //===================================data区域begin
    classId: string = '';
    classNum: number = 0;
    courseNum: number = 0;
    // 表格记录 hover 状态
    leftAlignId: any = '';
    classInfo: any = [
        {
            studentName: '',
            className: '',
            courseName: [],
            _id: 1
        }
    ];
    columns: any = [
        {
            dataIndex: 'studentName',
            title: '学生名称',
            scopedSlots: {
                customRender: ''
            }
        },
        {
            dataIndex: 'className',
            title: '班级名称',
            scopedSlots: {
                customRender: 'className'
            }
        },
        {
            dataIndex: 'courseName',
            title: '课程名称',
            scopedSlots: {
                customRender: 'courseName'
            }
        }
    ];
    pager: any = {
        default: {pagesize: 200, pagenum: 1, total: 0, rows: []}
    };
    loading: boolean = false;
    //===================================data区域end
    //===================================computed区域begin
    //===================================computed区域end
    //===================================methods区域begin
    handleCancel() {
        this.$emit('closeStudentModal');
    }
    getList() {
        let me = this;
        me.loading = true;
        let urlQueryParmas = {
            classId: me.classId
        };
        classesApi.getCourseListByClassId({
            context: me,
            pager: me.pager.default,
            urlQueryParmas: urlQueryParmas,
            appendAttributes: [
                {
                    key: 'teacherName',
                    value: ''
                }
            ],
            afterRender(data: any) {
                me.loading = false;
                let dataList = data.data.list;
                // console.log(dataList);
                me.classInfo[0].className = dataList[0].className;
                for (let i = 0; i < dataList.length; i++) {
                    me.classInfo[0].courseName.push(dataList[i].courseName);
                }
                return data;
            }
        });
    }
    //===================================methods区域end
    created() {
        // console.log(this.studentInfo);
        if (this.studentInfo) {
            this.classId = this.studentInfo.classId;
            this.classNum = this.studentInfo.classCount;
            this.courseNum = this.studentInfo.courseCount;
            this.classInfo[0].studentName = this.studentInfo.nickname;
        }
        this.getList();
    }
    mounted() {}
}
